import * as R from 'ramda'

// TODO Abstract this utilsV2 util library
/**
 * This utility function takes arrays and converts them to ordered objects so
 * that we can store them in Redux while maintaining order.
 *
 * @param {string} prop - Property from array to use as the key
 * @returns {Object} - An object with ordered entries
 */
export const arrayToOrderedMap = prop =>
  R.pipe(
    R.converge(R.zip, [R.pluck(prop), R.identity]),
    R.map(([k, v]) => [String(k), v]),
    R.fromPairs,
  )
